import { render, staticRenderFns } from "./GraciasCA.vue?vue&type=template&id=158f83ed&scoped=true"
import script from "./GraciasCA.vue?vue&type=script&lang=js"
export * from "./GraciasCA.vue?vue&type=script&lang=js"
import style0 from "./GraciasCA.vue?vue&type=style&index=0&id=158f83ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158f83ed",
  null
  
)

export default component.exports